// @flow
import React from 'react';
import { colors } from '../constants';
import styled from 'styled-components';
import type { IconProps } from './types';

type TrashCanProps = IconProps & {
  color: string,
  hoverColor: string,
  onClick: Function,
  verticalAlign: string,
  size: number,
};

const TrashCanSvg = ({ size, color, className, onClick }: TrashCanProps) => (
  <svg
    width={size}
    height={size}
    className={className}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="nonzero"
        d="M11.8064516,1 C12.6794178,1 13.3870968,1.70515152 13.3870968,2.575 L13.3870968,2.575 L13.387,3.7 L14.9677419,3.7 C16.0901271,3.7 17,4.60662338 17,5.725 L17,7.075 C17,7.61934566 16.6120046,8.07339377 16.0965466,8.17754194 L16.0967742,16.525 C16.0967742,17.8919048 14.9847073,19 13.6129032,19 L6.38709677,19 C5.01529272,19 3.90322581,17.8919048 3.90322581,16.525 L3.90345342,8.17754194 C3.38799543,8.07339377 3,7.61934566 3,7.075 L3,5.725 C3,4.60662338 3.90987293,3.7 5.03225806,3.7 L6.612,3.7 L6.61290323,2.575 C6.61290323,1.75347643 7.24413537,1.07885849 8.04967746,1.00643651 L8.19354839,1 Z M14.7419355,8.2 L5.25806452,8.2 L5.25806452,16.525 C5.25806452,17.1463203 5.76354948,17.65 6.38709677,17.65 L13.6129032,17.65 C14.2364505,17.65 14.7419355,17.1463203 14.7419355,16.525 L14.7419355,8.2 Z M8.19354839,10 C8.56767677,10 8.87096774,10.3022078 8.87096774,10.675 L8.87096774,10.675 L8.87096774,14.9539551 C8.87096774,15.3267473 8.56767677,15.6289551 8.19354839,15.6289551 C7.81942001,15.6289551 7.51612903,15.3267473 7.51612903,14.9539551 L7.51612903,14.9539551 L7.51612903,10.675 C7.51612903,10.3022078 7.81942001,10 8.19354839,10 Z M11.8064516,10 C12.18058,10 12.483871,10.3022078 12.483871,10.675 L12.483871,10.675 L12.483871,14.9539551 C12.483871,15.3267473 12.18058,15.6289551 11.8064516,15.6289551 C11.4323232,15.6289551 11.1290323,15.3267473 11.1290323,14.9539551 L11.1290323,14.9539551 L11.1290323,10.675 C11.1290323,10.3022078 11.4323232,10 11.8064516,10 Z M14.9677419,5.05 L5.03225806,5.05 C4.65812969,5.05 4.35483871,5.35220779 4.35483871,5.725 L4.35483871,6.85 L15.6451613,6.85 L15.6451613,5.725 C15.6451613,5.35220779 15.3418703,5.05 14.9677419,5.05 Z M11.8064516,2.35 L8.19354839,2.35 C8.06883893,2.35 7.96774194,2.45073593 7.96774194,2.575 L7.96774194,2.575 L7.967,3.7 L12.032,3.7 L12.0322581,2.575 C12.0322581,2.47144661 11.9620518,2.3842322 11.8664799,2.35803722 L11.8064516,2.35 Z"
      />
    </g>
  </svg>
);

// $FlowFixMe - Add type notiation when GHR upgrades to Babel 7 - styled<TrashCanProps>(TrashCanSvg)
const TrashCan = styled(TrashCanSvg)`
  vertical-align: ${(props: TrashCanProps) => props.verticalAlign};
  cursor: pointer;

  &:hover {
    path {
      fill: ${(props: TrashCanProps) => props.hoverColor};
    }
  }
`;

TrashCan.displayName = 'TrashCan';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.104.0. To view the error, delete this comment and run Flow. */
TrashCan.defaultProps = {
  size: '20px',
  color: colors.mediumGrey,
  hoverColor: colors.darkestGrey,
  verticalAlign: 'middle',
};

export default TrashCan;
